import { functions } from '../firebase';
import { CloudFunctions } from '../types';

// Uncomment the next line to use local cloud functions
// functions.useEmulator("localhost", 5001);

export const cloudFunction = (functionName: CloudFunctions) => {
  return functions.httpsCallable(functionName)
};
